import { ActivityApi, Configuration, DocumentApi, MotivationClassifierApi, PetApi } from "@myfamilysrl/memopet_typescript_axios_sdk";
import { toast } from "react-toastify";

export default function useFullPet() {
	const startActivity = (accessToken, petId) =>
		new Promise(async (resolve, reject) => {
			const memopetConfig = new Configuration({
				basePath: process.env.REACT_APP_MEMOPET_API,
				// basePath: "http://10.12.34.42:5273", //piru
				accessToken: accessToken,
			});

			const memopetApi = new ActivityApi(memopetConfig);

			await memopetApi
				.apiActivityStartPost({
					petId: petId,
				})
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					console.error("error on start activity", err);
					reject(err);
				});
		});

	const endActivity = (accessToken, activityId) =>
		new Promise(async (resolve, reject) => {
			const memopetConfig = new Configuration({
				basePath: process.env.REACT_APP_MEMOPET_API,
				// basePath: "http://10.12.34.42:5273", //piru
				accessToken: accessToken,
			});

			const memopetApi = new ActivityApi(memopetConfig);

			await memopetApi
				.apiActivityEndPost({
					id: activityId,
				})
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					console.error("end activity err", err);
					reject(err);
				});
		});

	const deleteActivity = (accessToken, activityId) =>
		new Promise(async (resolve, reject) => {
			const memopetConfig = new Configuration({
				basePath: process.env.REACT_APP_MEMOPET_API,
				// basePath: "http://10.12.34.42:5273", //piru
				accessToken: accessToken,
			});

			const memopetApi = new ActivityApi(memopetConfig);

			await memopetApi
				.apiActivityIdDelete({
					id: activityId,
				})
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					console.error("error on delete activity", err);
					reject(err);
				});
		});

	const downloadDocument = (accessToken, documentId) =>
		new Promise(async (resolve, reject) => {
			const memopetConfig = new Configuration({
				basePath: process.env.REACT_APP_MEMOPET_API,
				// basePath: "http://10.12.34.42:5273", //piru
				accessToken: accessToken,
			});

			const memopetApi = new DocumentApi(memopetConfig);

			await memopetApi
				.apiDocumentFielVisibilityDocumentDownloadGet(documentId)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					console.error("error on download document", err);
					reject(err);
				});
		});

	const getTodayActivity = async (accessToken, petId) => {
		let data = null;
		const memopetConfig = new Configuration({
			basePath: process.env.REACT_APP_MEMOPET_API,
			// basePath: "http://10.12.34.42:5273", //piru
			accessToken: accessToken,
		});

		const memopetApi = new ActivityApi(memopetConfig);

		await memopetApi
			.apiActivityGetDailyAllActivityByPetPetIdGet(petId, navigator.language.substring(0, 2))
			.then((res) => {
				data = res;
			})
			.catch((err) => console.error("error on getTodayActivity", err));

		return data;
	};

	const getActivityTypeCollection = async (accessToken) => {
		let data = null;
		const memopetConfig = new Configuration({
			basePath: process.env.REACT_APP_MEMOPET_API,
			// basePath: "http://10.12.34.42:5273", //piru
			accessToken: accessToken,
		});
		const memopetApi = new MotivationClassifierApi(memopetConfig);

		await memopetApi
			.apiMotivationClassifierByTypeGet("activity", navigator.language.substring(0, 2))
			.then((res) => {
				data = res;
			})
			.catch((err) => console.error("error on getActivityTypeCollection", err));

		return data;
	};

	const todayActivityPost = async (accessToken, petId, motivationTypeId, motivationDescription = "", petName = "") => {
		new Promise(async (resolve, reject) => {
			let data = null;
			const memopetConfig = new Configuration({
				basePath: process.env.REACT_APP_MEMOPET_API,
				// basePath: "http://10.12.34.42:5273", //piru
				accessToken: accessToken,
			});
			const memopetApi = new ActivityApi(memopetConfig);

			await memopetApi
				.apiActivityDailyActivityPost(petId, motivationTypeId)
				.then((res) => {
					data = res;
					resolve(res);
					memopetApi
						.apiActivityActivityPushNotificationPatch(petId, `${petName} - ${motivationDescription}`)
						.then((result) => {
							console.warn("send push");
						})
						.catch((error) => {
							console.warn("error push");
						});
				})
				.catch((err) => console.error("error on todayActivityPost", err));
		});
	};

	const currentLocation = async (accessToken, petId, latitude, longitude, motivation) => {
		new Promise(async (resolve, reject) => {
			let data = null;
			const memopetConfig = new Configuration({
				basePath: process.env.REACT_APP_MEMOPET_API,
				// basePath: "http://10.12.34.42:5273", //piru
				accessToken: accessToken,
			});
			const memopetApi = new PetApi(memopetConfig);

			await memopetApi
				.apiPetPositionPushNotificationPatch(petId, latitude, longitude, 'Are you looking for your pet? Click here and reach out!')
				.then((result) => {
					console.warn("send push");
				})
				.catch((error) => {
					console.warn("error push");
				});
		});
	};

	//   apiPetPositionPushNotificationPatch

	return { startActivity, endActivity, deleteActivity, downloadDocument, getTodayActivity, getActivityTypeCollection, todayActivityPost, currentLocation };
}
